module.exports = new __parcel__URL__("stealthcancel.42022f52.png").toString();